import styled from 'styled-components';
import { focusMixin } from '../../mixins/focusMixin';

/**
 * A wrapper for `Dialog` body content
 * (content will automatically be wrapped when using the `body` prop).
 *
 * @related [`Dialog`]
 * @since 7.0.0
 */
var DialogBody = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogBody",
  componentId: "c11n-8-107-0__sc-1l4a94i-0"
})(["", ""], function (props) {
  return focusMixin(props);
});
DialogBody.displayName = 'DialogBody';

/** @component */
export { DialogBody };